__turbopack_context__.v({
  "paper": "_2uxG3W_paper",
  "scroll": "_2uxG3W_scroll",
});
